import React, { useMemo } from 'react'

import {
  arrayOf, oneOfType, shape, string,
} from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import MainFilters from './Components/MainFilters/MainFilters'
import SecondaryFilters from './Components/SecondaryFilters/SecondaryFilters'
import { withDevFallbackTags } from './devFallbackTags'

// Backend (Items::SerializeCollection) emits tags as `[["slug", { thumbnailUrl, ... }], ...]`.
// Flatten to a simple `string[]` here so downstream filters work with a single shape.
function SearchPage({ tags = EMPTY_ARRAY }) {
  const suggestedTags = useMemo(() => {
    const normalized = tags.map(entry => (Array.isArray(entry) ? entry[0] : entry)).filter(Boolean)
    return withDevFallbackTags(normalized)
  }, [tags])

  return (
    <div className="search-page">
      <div className="search-page__filters-container">
        <MainFilters />
        <SecondaryFilters suggestedTags={suggestedTags} />
      </div>
    </div>
  )
}

SearchPage.propTypes = {
  tags: arrayOf(oneOfType([
    arrayOf(oneOfType([string, shape({})])),
    string,
  ])),
}

export default SearchPage
